import { Button } from '@mui/material';
import { IconCopy, IconTrash } from '@tabler/icons-react';
import React from 'react';

export default function BtnCopy({
  onClick,
  width,
  fullWidth,
  style,
  iconSize = 20,
  variant = 'outlined',
  ...props
}) {
  return (
    <Button
      variant={variant}
      width={width}
      fullWidth={fullWidth}
      onClick={onClick}
      style={style}
      {...props}>
      <IconCopy size={iconSize} />
    </Button>
  );
}
